export const QR_SETTINGS = {
  QR_TYPE: "qrType",
  QR_CONTENT: "qrContent",
  SHOW_GTIN: "showGtin",
  CAN_SMARTPAGE: "canHaveSmartpage",
  SMARTPAGE_FILE: "smartpageFile",
  QR_INDUSTRY: "industry",
  UPDATED: "updated",
  DATA_SOURCE: "source",
  ERROR_CORRECTION: "errorCorrection"
}
export const QR_TYPES = {
  QR_CODE: "qr-code",
  QR_BARCODE: "qr-barcode",
  QR_CODE_AND_QR_BARCODE: "qr-code-barcode",
  QR_CODE_AND_BARCODE: "qr-code-and-barcode"
}

export const QR_CONTENT = {
  NONE: "none",
  REDIRECT: "redirect",
  CUSTOM: "custom",
  SMART: "smart"
}

export const QR_STATUS = {
  DRAFT: 0,
  ACTIVE: 1
}

export const QR_CONTENT_STATUS = {
  NONE: 0,
  UPDATED: 1,
  PENDING: 2
}

export const QR_INDUSTRIES = {
  WINE: "wine",
  FOOD: "food"
}
export const SMART_PAGE_TABS = {
  INGREDIENTS: 0,
  CUSTOM_PAGE: 1
}

export const SMARTPAGE_RENDER_TABS = {
  NUTRITION: 0,
  COMPOSITION: 0,
  USE: 1,
  INGREDIENTS: 1,
  COSMETIC_INGREDIENTS: 0,
  DETAILS: 0,
  IMPACT: 1,
  CIRCULARITY: 2,
  ALLERGENS: 2,
  DESIGNATION: 2,
  COMPANY: 3,
  MANUAL: 1,
  SUSTAINABILITY: 2
}

export const QR_LINK_SETUP_DEFAULT_VALUE = Object.freeze({
  title: "",
  type: "",
  href: "",
  lang: ""
})

export const QR_LINK_SETUP_PRIORITY = {
  defaultLink: "gs1:defaultLink"
}

export const LINK_TYPE = Object.freeze({
  ALL: "linkType=all",
  LINKSET: "linkType=linkset"
})

export const LINK_SETUP_CONTENT = {
  LINKSETUP: "linkSetup",
  QR_VARIANT: "qrVariant",
  QR_VARIANT_LINKSETUP: "qrVariantLinkSetup"
}

export const QR_VARIANT_QUALIFIERS = {
  BATCH_NUMBER: "10",
  SERIAL_NUMBER: "21",
  CPV: "22"
}

export const QR_VARIANT_ATTRIBUTES = {
  EXPIRATION_DATE: "17",
  PACKAGING_DATE: "13",
  NET_WEIGHT: "3100",
  COUNTRY_OF_ORIGIN: "422",
  BEST_BEFORE_DATE: "15",
  PRODUCTION_DATE: "11"
}

/**
 * QR_LINK_VARIANT_DEFAULT_VALUE
 *
 * Object with default values for qr variant attributes and qualifiers.
 *
 * The object is generated by mapping the values of both QR_VARIANT_ATTRIBUTES and QR_VARIANT_QUALIFIERS
 * to an empty string.
 *
 * @constant
 * @type {Object<string,string>}
 * @example
 * {
 *   "17": "",
 *   "13": "",
 *   "3100": "",
 *   "422": "",
 *   "10": "",
 *   "21": "",
 *   "22": ""
 * }
 */
export const QR_LINK_VARIANT_DEFAULT_VALUE = Object.freeze(
  Object.fromEntries(
    Object.values({ ...QR_VARIANT_ATTRIBUTES, ...QR_VARIANT_QUALIFIERS }).map((value) => {
      return [value, ""]
    })
  )
)

export const QR_FORMATS = {
  PNG: "png",
  PDF: "pdf",
  SVG: "svg"
}

export const SMARTPAGE_DATA_SOURCE_TYPE = {
  LOCAL: "local",
  OFF: "off"
}

export const QR_LINKS_TYPES = {
  qrVariant: "QrVariant",
  qrLink: "QrLink"
}
